"use client";

import Link from "next/link";
import { ShoppingCart } from "lucide-react";
import { useCart } from "@/components/cart/CartProvider";

export function CartIcon() {
  const { cart } = useCart();
  const count = cart?.itemCount ?? 0;
  return (
    <Link
      href="/cart"
      aria-label={`Shopping cart${count > 0 ? `, ${count} items` : ""}`}
      className="relative inline-flex h-9 w-9 items-center justify-center rounded-full text-[rgb(var(--color-secondary))] hover:bg-[var(--color-surface-muted)] hover:text-[rgb(var(--color-primary))]"
    >
      <ShoppingCart className="h-5 w-5" aria-hidden />
      {count > 0 && (
        <span className="absolute -right-1 -top-1 flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-[rgb(var(--color-primary))] px-1 text-[10px] font-semibold text-white">
          {count > 99 ? "99+" : count}
        </span>
      )}
    </Link>
  );
}
